module.exports = __webpack_public_path__ + "img/hr-logistic-robot-shadow.96f5cfa6.png";